<template>
  <div class="graphic-symbol-two-content" id="identidade-visual-grafismos-forma-correta-de-usar-o-grafismo-com-o-simbolo-globo" data-search-anchor>    
    <div class="description-graphic-symbol-two-title-icons-wrapper">
      <div class="graphic-symbol-two-icon-wrapper-first">
        <IconCheck />
        <p class="graphic-symbol-two-description">{{ graphicSymbolDescription1 }}</p>
      </div>
      <div class="graphic-symbol-two-icon-wrapper-sec">
        <IconCheck />
        <p class="graphic-symbol-two-description">{{ graphicSymbolDescription2 }}</p>
      </div>
    </div>
    <div
      class="graphic-symbol-two-card-item"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class GraphicsSymbolTwoSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store) 

  get graphicSymbolDescription1(): string {
    return this.getElementText(3, 1)
  }

  get graphicSymbolDescription2(): string {
    return this.getElementText(3, 2)
  }

  get graphicSymbolDescription3(): string {
    return this.getElementText(3, 3)
  }

  get ImageSrc(): string {
    return this.getElementMedia(3, 3)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-symbol-two-content {
  display: grid;
  max-width: 1045px;
  width: 100%;
}

.description-graphic-symbol-two-title-icons-wrapper { 
  position: relative;  
  display: grid;
  grid-template-columns: 51.2% 48.8%;
  width: 100%;
  max-width: 1032px;
  margin-top: 2rem;
}

.graphic-symbol-two-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  width: 378px; 
  padding-left: 7px; 
}

.graphic-symbol-two-icon-wrapper-first {
  display: flex;  
  align-items: center;
}

.graphic-symbol-two-icon-wrapper-sec {
  display: flex;
  align-items: center;
}

.graphic-symbol-two-card-item {
  position: relative;
  
  width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

</style>
